import { Box, Typography, Button, Modal } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { modalStyle2 } from "./ModalComponentRecommendations.jsx";

export default function ConfirmationModalRecommendations({
  confirmationOpen,
  setConfirmationOpen,
  action,
  reason,
  handleConfirmAction,
  loading,
}) {
  const { t } = useTranslation("recommendations");
  const verb = t(`buttons.${action}`);

  return (
    <Modal open={confirmationOpen} onClose={() => setConfirmationOpen(false)}>
      <Box sx={modalStyle2}>
        <Typography variant="h6">
          {t("confirmModal.title", { actionLower: verb.toLowerCase() })}
        </Typography>
        <Typography sx={{ mt: 1, fontStyle: "italic", fontSize: "0.9rem" }}>
          <strong>{t("labels.reason")} </strong>
          {reason}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => setConfirmationOpen(false)}
          >
            {t("buttons.cancel")}
          </Button>
          <LoadingButton
            variant="contained"
            color="success"
            loading={loading}
            loadingPosition="end"
            endIcon={<span />}
            onClick={handleConfirmAction}
            sx={{
              pr: loading ? 3.5 : undefined, 
              "& .MuiLoadingButton-loadingIndicator": { right: 10 },
            }}
          >
            {t("buttons.confirm")}
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}
